import React, {Component} from 'react';
import {Modal, Tabs, Input, message, Empty} from "antd";
import OptionRange from "../../components/fileLibrary/option/OptionRange";
import {optionConfig} from "../ResourcesFile/option-config";
import BaseComponent from "../../../../base/BaseComponent";
import {getInfoFromLocalStorage} from "../../../../actions";
import {findObject} from "../../../editor/floatTool/securityCheck";
import {Scrollbars} from "react-custom-scrollbars";
import {uuid} from "../../../../utils";
import $ from "jquery";
import close from "./close.png";
import {AUDIO_TYPE, PIC_TYPE, VIDEO_TYPE} from "../../../../constants";

const {Search} = Input;
const {TabPane} = Tabs;
const tabList = [];

/**通用的资源库瀑布流dialog页面*/
class CurrencyResourceDialogComponent extends BaseComponent {

    static defaultProps = {
        visible: false,
        title: "资源库选择",
        singleChoice: false,//是否单选，默认多选
        width: 920,
        tabList: tabList,
        dataSource: [],
        tabChange: () => {
        },
        onOk: () => {
        },
        changeStatus: () => {
        },
        onScroll: () => {
        },//内容区域滚动条滚动时触发
        onScrollToBottom: () => {
        },//内容区域滚动条到底部时触发
        newPicType: ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'JPG', 'JPEG', 'GIF', 'PNG', 'BMP'],
    };

    constructor(props) {
        super(props);
        this.state = {
            visible: props.visible,
            checkedData: [],
        };
    }

    dialogKey = uuid();
    tabsKey = uuid();
    contentKey = uuid();
    show = () => {
        this.key = null;
        this.value = "";
        this.dialogKey = uuid();
        this.tabsKey = uuid();
        this.allStatus = {};
        this.contentKey = uuid();
        this.setState({visible: true, checkedData: []});
    };

    key;
    value = "";
    tabChange = (key) => {
        this.key = key;
        this.value = "";
        this.searchKey = uuid();
        this.allStatusKey = uuid();
        this.contentKey = uuid();
        this.props.tabChange(key);
        this.setState({checkedData: []});
    };

    searchKey = uuid();
    searchChange = (value) => {
        this.value = value;
        this.contentKey = uuid();
        this.props.searchChange(this.allStatus, this.key, value);
        this.setState({checkedData: []});
    };

    allStatusKey = uuid();
    allStatus = {};
    changeStatus = (data, all) => {
        let _all = {};
        all && all.map(item => {
            if (typeof item.data === "string") {
                if (item && item.data && item.data.indexOf("不限") === -1) {
                    _all[item.type] = item.data;
                } else {
                    delete _all[item.type];
                }
            } else if (typeof item.data === "number") {
                _all[item.type] = item.data;
            } else {
                delete _all[item.type];
            }
        });
        this.allStatus = _all;
        this.contentKey = uuid();
        this.props.changeStatus(this.allStatus, this.key, this.value);
        this.setState({checkedData: []});
    };

    dataSourceComponents = [];

    onClose = () => {
        if (this.props.onCloseCall && typeof this.props.onCloseCall == 'function') {
            this.props.onCloseCall();
        }
    }

    render() {
        this.dataSourceComponents = [];
        let newOptionConfig = optionConfig
        try {
            let zyk = this.sysConfigGetValueByKey("zyk_screen_optionConfig", "")
            newOptionConfig = JSON.parse(zyk)
        } catch (e) {
            console.log(e.toString())
        }
        let configs = newOptionConfig[this.props.authType] && newOptionConfig[this.props.authType][this.props.indexName] || [];
        let padding = 20;
        let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
        return (
            <Modal
                key={this.dialogKey}
                maskClosable={false}
                width={this.props.width}
                title={this.props.title}
                visible={this.state.visible}
                bodyStyle={{padding: "0 0 10px 0"}}
                keyboard={true}
                onCancel={() => this.setState({visible: false}, () => {
                    this.onClose()
                })}
                onOk={() => {
                    if (this.props.onCallBackOk && typeof this.props.onCallBackOk == 'function') {
                        this.props.onCallBackOk(this.state.checkedData, (flag) => {
                            if (flag) {
                                this.setState({visible: false}, () => {
                                    this.onClose()
                                });
                            }
                        });
                    } else if (this.props.onOk && typeof this.props.onOk == 'function') {
                        this.setState({visible: false}, () => {
                            this.onClose()
                        });
                        this.props.onOk(this.state.checkedData);
                    }
                }}
            >
                {
                    this.props.tabList && this.props.tabList.length > 0 ? <div>
                        {this.props.tabList && this.props.tabList.length > 0 &&
                        <div className={"currencyResourceDialog"}>
                            <Tabs key={this.tabsKey} defaultActiveKey={(() => {
                                if (!this.key) {
                                    this.key = this.props.tabList[0].key;
                                }
                                return this.key;
                            })()} onChange={(key) => this.tabChange(key)}>
                                {this.props.tabList.map(item => {
                                    return <TabPane tab={item.name} key={item.key}/>;
                                })}
                            </Tabs>
                            <style>{`
                            .currencyResourceDialog {padding: 10px ${padding}px 0 ${padding}px; border-bottom:1px solid #e8e8e8}
                            .currencyResourceDialog .ant-tabs-bar{border: 0px}
                            .currencyResourceDialog .ant-tabs-tab{padding-left:5px;padding-right:5px}
                        `}</style>
                        </div>}

                        <div style={{margin: padding}}><Search
                            placeholder="请输入" key={this.searchKey}
                            onSearch={value => this.searchChange(value)}
                            // onBlur={(e)=>{
                            //     if (!e.target.value){
                            //         this.searchChange()
                            //     }
                            // }}
                            style={{width: 200}}
                        />
                            <span style={{float: "right", letterSpacing: 0}}>
                            共<span style={{
                                color:newSecondSelectColor,
                                margin: "0 5px"
                            }}>{this.props.count ? this.props.count : 0}</span>条记录
                            <span style={{marginLeft: 20}}>已选（<span style={{
                                color: newSecondSelectColor,
                                margin: "0 5px"
                            }}>{this.state.checkedData.length}</span>）</span>
                        </span>
                        </div>

                        <div style={{
                            height: 35,
                            padding: `0px ${padding}px`,
                            borderBottom: "1px solid #e8e8e8",
                            marginBottom: "10px"
                        }}>
                            <OptionRange
                                key={this.allStatusKey}
                                configs={configs}
                                configName={this.props.indexName}
                                onClickCall={(data, all) => {
                                    this.changeStatus(data, all)
                                }}/>
                        </div>

                        {(this.props.dataSource && this.props.dataSource.length > 0) ?
                            <Scrollbars
                                key={this.contentKey}
                                autoHeight={true}
                                autoHeightMax={360}
                                onScroll={(e) => {
                                    this.props.onScroll(this.key, this.value);
                                    if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight) {
                                        // 滚动到底部需要做的事情
                                        this.props.onScrollToBottom(this.allStatus, this.key, this.value);
                                    }
                                }}
                            >
                                <div style={{padding: "0px 10px 0px 10px"}}>
                                    {this.props.dataSource.map((item, index) => {
                                        let itemComponent;
                                        return <item.component
                                            ref={r => {
                                                if (r) {
                                                    this.dataSourceComponents.push(r);
                                                    itemComponent = r;
                                                }
                                            }}
                                            onClick={(data, checked) => {
                                                let checkedData = [];
                                                this.dataSourceComponents.map(item => {
                                                    let checkedValue = item.checkedAndReturn();
                                                    if (this.props.singleChoice) {//如果需要单选
                                                        if (checkedValue && (itemComponent === item)) {
                                                            checkedData = [checkedValue];
                                                        } else {
                                                            item && item.cancelChecked();
                                                        }
                                                    } else {
                                                        if (checkedValue) {
                                                            checkedData.push(checkedValue)
                                                        }
                                                    }
                                                });
                                                this.setState({checkedData});
                                            }}
                                            key={index} data={item}/>
                                    })}
                                </div>
                            </Scrollbars> : <Empty style={{margin: "10px auto"}}/>
                        }
                    </div> : <Empty style={{padding: 15}}/>
                }

            </Modal>
        );
    }
}


class CurrencyResourceDialog extends BaseComponent {

    static defaultProps = {
        indexName: "picture",
        singleChoice: false,//是否单选，默认多选
        onOk: () => {
        },
        onCloseCall: () => {
        },
        isShowAllPicType: false, //展现所遇图片类型？
    };
    start = 1;
    size = 15;

    resetParams = () => {
        this.start = 1;
        this.size = 15;
    };

    constructor(props) {
        super(props);
        let tabList = this.getAuthTab();
        this.state = {
            tabList,
            dataSource: [],
            count: 0,
            videoMaxSize: this.sysConfigGetValueByKey("Upload.max.videoSize", "500") * 1,
        };
        this.initDataSource(tabList);
    }

    initDataSource = (tabList) => {
        if (!tabList || tabList.length === 0) {
            return;
        }
        let res = findObject(tabList, "checked", "1");
        if (!res) {
            res = tabList[0];
        }
        this.loadDataSource(res);
    };

    loadDataSource = (tab, search = "", start = 1, size = 15, other = {}) => {
        let {indexName} = this.props;
        let loadDataModule = tab.loadDataModule;
        let fun = require(`./load/${loadDataModule}`).default;
        fun && fun({indexName, start, size, search, other}).then(data => {
            if (start != 1 && data.data) {
                this.state.dataSource = [...this.state.dataSource, ...data.data];
            } else {
                this.state.dataSource = data.data || data;
                this.state.count = data.count;
            }
            this.setState({});
        }).catch(e =>
            console.log(e)
        );
    };

    show = () => {
        this.initDataSource(this.state.tabList);
        this.dialog.show();
    };

    getAuthTab = () => {
        let tabListConfig = JSON.parse(this.sysConfigGetValueByKey("currency.resource.dialog.tab", `
        [
            {"attr":"menuCode", "value":"allResource", "name":"全部资源", "loadDataModule":"allResource"},
            {"attr":"menuCode", "value":"publishResource", "name":"公共资源", "loadDataModule":"publishResource"},
            {"attr":"menuCode", "value":"unitResources", "name":"单位资源", "loadDataModule":"unitResources"},
            {"attr":"menuCode", "value":"personalResources", "name":"个人资源", "loadDataModule":"personalResources"},
            {"attr":"menuCode", "value":"collection", "name":"我的收藏", "loadDataModule":"collection"}
        ]`));
        let tabList = [];
        let menu = getInfoFromLocalStorage("menu");
        tabListConfig.map(item => {
            let res = findObject(menu, item.attr, item.value);
            if (res) {
                item.key = item.value;
                tabList.push(item);
            }
        });
        return tabList;

    };

    checkPicture = (fileList) => {
        let newType;
        let maxSize;
        let newFileList = [];
        if (this.props.isShowAllPicType) {
            newType =this.sysConfigGetValueByKey(" zyk_correct_format",["jpg", "jpeg", "png", "bmp", "webp", "JPG", "JPEG", "PNG", "BMP","WEBP"]);
        } else {
            newType = ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'JPG', 'JPEG', 'GIF', 'PNG', 'BMP'];
        }
        fileList.forEach(item=>{
            if(newType && newType.indexOf(item.suffix) == -1) {
                message.destroy();
                message.error('暂不支持该文件类型！');
                return false
            }
            if(maxSize && (item.size / 1024 / 1024) > maxSize) {
                message.destroy();
                message.error(`文件大小不能超过${maxSize}MB！`);
                return false
            }
            newFileList.push(item)
        });
        return newFileList
    };

    checkVideo = (fileList) => {
        let newType;
        let maxSize;
        let newFileList = [];
        newType = VIDEO_TYPE;
        maxSize = this.sysConfigGetValueByKey("Upload.max.videoSize", "500") * 1;
        fileList.forEach(item=>{
            if(newType && newType.indexOf(item.suffix) == -1) {
                message.destroy();
                message.error('暂不支持该文件类型！');
                return false
            }
            if(maxSize && (item.size / 1024 / 1024) > maxSize) {
                message.destroy();
                message.error(`文件大小不能超过${maxSize}MB！`);
                return false
            }
            newFileList.push(item)
        });
        return newFileList
    };

    checkAudio = (fileList) => {
        let newType;
        let maxSize;
        let newFileList = [];
        newType = AUDIO_TYPE;
        fileList.forEach(item=>{
            if(newType && newType.indexOf(item.suffix) == -1) {
                message.destroy();
                message.error('暂不支持该文件类型！');
                return false
            }
            if(maxSize && (item.size / 1024 / 1024) > maxSize) {
                message.destroy();
                message.error(`文件大小不能超过${maxSize}MB！`);
                return false
            }
            newFileList.push(item)
        });
        return newFileList
    }

    onOk = (fileList) => {
        let newFileList = [];
        try {
            newFileList = JSON.parse(JSON.stringify(fileList))
        } catch (e) {
            console.log(e.toString())
        }
        switch (this.props.indexName) {
            case "picture":
                newFileList = this.checkPicture(newFileList);
                break;
            case "video":
                newFileList = this.checkVideo(newFileList);
                break;
            case "audio":
                newFileList = this.checkAudio(newFileList);
                break;
        }
        this.props.onOk(newFileList || []);
    };

    render() {
        return <CurrencyResourceDialogComponent
            ref={dialog => {
                this.dialog = dialog
            }}
            tabList={this.state.tabList}
            authType={"dept"}
            onCallBackOk={this.props.onCallBackOk}
            onCloseCall={this.props.onCloseCall}
            indexName={this.props.indexName}
            onOk={checkedData => {
                this.onOk(checkedData)
            }}
            singleChoice={this.props.singleChoice}
            tabChange={(key) => {
                this.resetParams();
                let findResult = findObject(this.state.tabList, "value", key);
                this.loadDataSource(findResult);
            }}
            searchChange={(data, key, value) => {
                this.resetParams();
                let findResult = findObject(this.state.tabList, "value", key);
                this.loadDataSource(findResult, value, 1, 15, data);
            }}
            dataSource={this.state.dataSource}
            count={this.state.count}
            changeStatus={(data, key, value) => {
                let findResult = findObject(this.state.tabList, "value", key);
                this.loadDataSource(findResult, value, 1, 15, data);
            }}
            onScrollToBottom={(data, key, value) => {
                // this.start++;
                let findResult = findObject(this.state.tabList, "value", key);
                if (this.state.count > this.start * this.size) {
                    this.start = this.start + 1;
                    this.loadDataSource(findResult, value, this.start, 15, data);
                }
            }}

        />

    }
}

export class Video extends BaseComponent {

    state = {
        show: false,
    }

    id = "b" + uuid();

    show = () => {
        $(`#${this.id}`).show();
        this.state.show = true;
        this.setState({});
    };

    hide = () => {
        $(`#${this.id}`).hide();
        this.state.show = false;
        this.setState({});
    };

    render() {
        let videoMaxWidth = document.body.clientWidth * 0.8;
        let videoMaxHeight = document.body.clientHeight * 0.8;
        return <div id={this.id} style={{display: "none"}}>
            <div style={{
                position: "fixed",
                top: 0,
                left: 0,
                zIndex: 9998,
                opacity: 0.4,
                background: "#000",
                width: document.body.clientWidth,
                height: document.body.clientHeight
            }}/>
            <table style={{position: "fixed", top: 0, left: 0, zIndex: 9999}} width={document.body.clientWidth}
                   height={document.body.clientHeight} cellSpacing={0} cellPadding={0} border={0}>
                <tbody>
                <tr>
                    <td valign={"middle"} align={"center"}>
                        {!this.state.show ? "" :
                            <video src={this.props.path} style={{maxWidth: videoMaxWidth, maxHeight: videoMaxHeight}}
                                   controls={true} controlsList={"nodownload"}/>}
                        <img onClick={(e) => {
                            this.hide();
                            e.stopPropagation();
                        }} src={close} style={{
                            position: "fixed",
                            top: 100,
                            right: 100,
                            width: 88,
                            height: 88,
                            cursor: "pointer"
                        }}/>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    }
}

export default CurrencyResourceDialog;